module.exports = __webpack_public_path__ + "static/media/water-normal-b.c1e04334.jpg";